import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetClose,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import { NAV_LINKS, LOGO_URL } from "@/constants/siteData";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 bg-background transition-shadow duration-300 ${
        scrolled ? "border-b-2 border-border" : "border-b-2 border-transparent"
      }`}
    >
      <nav className="container-xl flex items-center justify-between h-16 sm:h-18">
        <a href="#hero" className="flex items-center" data-testid="nav-logo">
          <img
            src={LOGO_URL}
            alt="Stoyga"
            className="h-7 w-auto object-contain grayscale invert mix-blend-screen sm:h-8"
          />
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-5">
          <Button asChild size="sm" variant="outlineLight">
            <a href="#contact">Inquire</a>
          </Button>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetContent side="right" className="bg-background border-l-2 border-border rounded-none w-[85%] sm:max-w-sm">
            <SheetTitle className="sr-only">Navigation menu</SheetTitle>
            <SheetDescription className="sr-only">
              Links to jump to sections of the Stoyga landing page
            </SheetDescription>
            <div className="flex flex-col h-full pt-8">
              <div className="flex flex-col gap-1">
                {NAV_LINKS.map((link) => (
                  <SheetClose asChild key={link.href}>
                    <a
                      href={link.href}
                      className="py-3.5 text-lg font-display text-foreground border-b-2 border-border hover:opacity-70 transition-opacity"
                    >
                      {link.label}
                    </a>
                  </SheetClose>
                ))}
              </div>
            </div>
          </SheetContent>
          <button
            className="lg:hidden flex items-center justify-center h-9 w-9 border-2 border-border text-foreground hover:bg-secondary transition-colors"
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            data-testid="nav-mobile-toggle"
          >
            <Menu className="h-4 w-4" />
          </button>
        </Sheet>
      </nav>
    </header>
  );
};
